import Link from "next/link";
import moment from "moment";
import classNames from "classnames";
import Button from "./Button";
import { useState } from "react";
import { generateNuggetsSummary } from "../utils/formatters";
import { leaving_soon_ms } from "../config";
import { CSSTransition } from "react-transition-group";
import styles from "./DropdownButton.module.css";
import ClickAwayListener from "./ClickAwayListener";

export default function PassItem({ item, onClick }) {
  const { id, name, pass_bucket, updated_at, tenant_slug } = item;

  const [open, setOpen] = useState(false);

  let inner;

  inner = (
    <div className="relative cursor-pointer transition z-10 duration-150 transform sm:group-hover:scale-105 sm:group-hover:shadow-outline-gray group-hover:z-20 group-hover:shadow-lg rounded-lg bg-gray-500 p-4 text-gray-50 font-bold group">
      <div className="flex items-center">
        <div className="flex-1 min-w-0">
          <div
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap"
            }}
          >
            {name}
          </div>
          <div className="text-xs font-normal">{pass_bucket.name}</div>
          <div className="text-xs font-normal">
            Updated {moment(updated_at).format("MMMM D, YYYY")}
          </div>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 text-gray-50 transition duration-150 ease-in-out"
          >
            <path
              fillRule="evenodd"
              d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
    </div>
  );

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className={classNames("relative text-left")}>
        <span onClick={() => setOpen(!open)}>
          <div className="focus:outline-none group p-2">{inner}</div>
        </span>
        <CSSTransition
          in={open}
          timeout={200}
          unmountOnExit
          mountOnEnter
          classNames={{ ...styles }}
          onMouseUp={() => setOpen(false)}
        >
          <div
            className="z-10 origin-top-right absolute right-0 mt-2 rounded-md shadow-lg w-64 mb-4"
            style={{ zIndex: 50000, marginTop: -30, marginRight: 10 }}
          >
            <div className="rounded-md bg-always-white shadow-xs">
              <div className="py-1">
                <div
                  className={classNames(
                    "block px-4 py-2 text-sm leading-5",
                    "border-always-gray-100",
                    "text-always-gray-700 hover:bg-always-gray-100 hover:text-always-gray-900 focus:outline-none focus:bg-always-gray-100 focus:text-always-gray-900 cursor-pointer"
                  )}
                  onClick={() => onClick(item)}
                >
                  Edit details
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </div>
    </ClickAwayListener>
  );
}
